// accessibility changes for survey taker to highlight error - MJXX
export const setFocus = (id, error = false) => {
  if (id && document.getElementById(id)) {
    if (error) {
      let nodeList = document
        .getElementById(id)
        .querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
      if (nodeList && Object.keys(nodeList).length > 0) {
        nodeList[0].tabIndex = 0;
        nodeList[0].focus();
      }
    } else {
      // document.getElementById(id).tabIndex = 0;
      // document.getElementById(id).focus();
      // keeping same code for now, acccessibility team should come back on this MJXX
      let nodeList = document
        .getElementById(id)
        .querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
      if (nodeList && Object.keys(nodeList).length > 0) {
        nodeList[0].tabIndex = 0;
        nodeList[0].focus();
      }
    }
  }
};
